import { CircularProgress } from "@mui/material";

const AuthButton = ({ title, isPending, formik }) => {
  return (
    <button
      className="h-[45px] flex items-center justify-center bg-secondary text-white w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryHover shadow-lg transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-disabled"
      type="submit"
      disabled={isPending || !formik.isValid}
    >
      {isPending ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <p>{title}</p>
      )}
    </button>
  );
};

export default AuthButton;
